import React, { useEffect, useState } from "react";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config/config";
import { error } from "jquery";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Box } from "@mui/material";
import moment from "moment";

const ItemDetilReportQty = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [Data, setData] = useState([]);
  const navigate = useNavigate();
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const value = searchParams.get("ID");
  console.log(value, "7777777", searchParams);

  const columns = [
    {
      header: "ID",
      accessorKey: "EntityID",
      size: "120",
      Cell: ({ row }) => {
        const { EntityID, Type } = row.original;

        const handleClick = () => {
          if (Type === "Sale") {
            navigate(`/manage-sales/${EntityID}`);
          } else if (Type !== "Inventory Adjustment") {
            navigate(`/manage-receiving/${EntityID}`);
          }
        };

        const isClickable = Type !== "Inventory Adjustment";

        return (
          <Box
            component="span"
            sx={{
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: isClickable ? "pointer" : "default",
              display: "flex",
              alignItems: "center",
              fontWeight: "700",
            }}
            onClick={isClickable ? handleClick : undefined}
          >
            {EntityID}
          </Box>
        );
      },
    },
    {
      header: "RefNo",
      accessorKey: "EntityRefNo",
      size: "120",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() =>
            row.original.Type == "Sale"
              ? navigate(`/sales-receipt/${row.original.EntityRefNo}`)
              : navigate(`/receiving-receipt/${row.original.EntityRefNo}`)
          }
        >
          {row.original.EntityRefNo}
        </Box>
      ),
    },
    {
      header: "EntityName",
      accessorKey: "EntityName",
      size: "120",
    },
    {
      header: "Transaction Date",
      accessorKey: "Createddate",
      size: "120",
      Cell: ({ row }) => <Box>{ moment(row.original.Createddate).format('MM/DD/yyyy')}</Box>,
    },
    {
      header: "QuickBookId",
      accessorKey: "EntityQucikBookID",
      size: "120",
    },
    {
      header: "Qty",
      accessorKey: "Qty",
      size: "120",

      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          {row.original.Qty}
        </Box>
      ),

      AggregatedCell: ({ row }) => {
        const isItemName = row.depth === 0;

        const calculateSaleTotal = (rows) => {
          return rows.reduce((total, r) => {
            const value = Number(r.original.Qty) || 0;
            if (r.original.DetilType === "Return / Memo") return total + value;
            if (r.original.DetilType === "Sale") return total - value;
            return total;
          }, 0);
        };

        const calculateReceiveTotal = (rows) => {
          console.log("Calling calculateReceiveTotal", rows);
          return rows.reduce((total, r) => {
            const value = Number(r.original.Qty) || 0;
            if (r.original.DetilType === "Receive") return total + value;
            if (r.original.DetilType === "Vendor Credit") return total - value;
            return total;
          }, 0);
        };

        let aggregatedTotal = Number(row.original.Qty) || 0;

        if (row.subRows && isItemName) {
          const type = (row.original.Type || "").trim().toLowerCase();

          console.log("Calling calculateReceiveTotal", type);
          if (type === "sale") {
            aggregatedTotal = calculateSaleTotal(row.subRows);
          } else if (type === "recevings") {
            aggregatedTotal = calculateReceiveTotal(row.subRows);
          }
        }

        return isItemName ? (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total :
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {aggregatedTotal}
            </Box>
          </>
        ) : null;
      },
    },
    {
      header: "Type",
      accessorKey: "Type",
      size: "120",
    },
    {
      header: "DetilType",
      accessorKey: "DetilType",
      size: "120",
    },
  ];

  useEffect(() => {
    if (value > 0) {
      axios
        .get(`${config.itemsBaseUrl}/items/ItemDetilQtyReport?itemId=${value}`)
        .then((res) => {
          setData(res.data.ResponseData);
        })
        .catch((error) => {});
    }
  }, [value]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Count Inventory</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/ItemQtyVerify">Item Qty Verify</Link>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <CommonMatrialReactTable
              MainHeading="Sonar POS"
              ReportHeading="Item Detil Qty Report"
              columns={columns}
              data={Data}
              startdate={startdate}
              enddate={enddate}
              columnGrouping={["Type"]}
              enableExpandAll={true}
              enableExpanding={true}
              expanded={true}
              enableRowSelection={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemDetilReportQty;
